import SeasonalPaywall, {
  SeasonalPaywallColors,
} from "../SeasonalPaywall/SeasonalPaywall"
import {
  Sun,
  HeaderBackground,
  FooterBackground,
} from "./SummerSVGs/SummerSVGs"
import styles from "./SummerPaywall.module.scss"
import useStrings from "../../localization/useStrings"

const summerColors: SeasonalPaywallColors = {
  scrollableGradient:
    "linear-gradient(to bottom, #8be2dc 0%, #8be2dc 20%, #fbf4e6 80%, #fbf4e6 100%)",
  header: {
    background: "#ffe4c3",
    title: "#b32f66",
    tagline: "#1d212b",
  },
  countdown: {
    boxBackground: "#e0feea",
    value: "#1d212b",
    unit: "#65686e",
    label: "#1d212b",
  },
  content: {
    background: "linear-gradient(180deg, #ffe4c3 0%, #fbf4e6 100%)",
    ultimateContainerBackground: "#d79a65",
    ultimateContainerText: "white",
  },
  features: {
    icon: "#d79a65",
    title: "#1d212b",
    description: "#65686e",
  },
  footer: {
    background: "#eddcc0",
    primaryButton: {
      background: "#b32f66",
      headerBackground: "#b32f66",
      contentBackground: "#fbf4e6",
      limitedTimeText: "#fbf4e6",
      saveTagText: "#fbf4e6",
      planTitle: "#1d212b",
      duration: "#65686e",
      originalPrice: "#65686e",
      discountedPrice: "#1d212b",
      monthlyRate: "#1d212b",
    },
    monthlyButton: {
      background: "#fbf4e6",
      border: "1px solid #e5e5e5",
      label: "#1d212b",
      price: "#1d212b",
    },
  },
  insets: {
    header: "#8CE2DD",
    footer: "#EDDCC0",
  },
}

const SummerPaywall = () => {
  const strings = useStrings()

  return (
    <SeasonalPaywall
      topDecoration={
        <div className={styles.sunIcon}>
          <Sun />
        </div>
      }
      headerBackground={<HeaderBackground />}
      footerBackground={<FooterBackground />}
      colors={summerColors}
      strings={{
        title: strings.summerSale.title,
        tagline: strings.summerSale.tagline,
        buttonTitle: strings.summerSale.pricing.summerSale,
      }}
    />
  )
}

export default SummerPaywall
